import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyBGGfvN2U0WZtbLfM1r3B_BYrKvS4WfNKE",
  authDomain: "cantalab-usa-crm-704de.firebaseapp.com",
  projectId: "cantalab-usa-crm-704de",
  storageBucket: "cantalab-usa-crm-704de.firebasestorage.app",
  messagingSenderId: "103514449429",
  appId: "1:103514449429:web:e214871d7c45f00ff6101c",
  measurementId: "G-NL1L1M19GL"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);

export { auth, db, storage, firebaseConfig };
